export function iconFaucet({ className }) {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 54 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M23.3333 16.6667V6.66667H10V0H43.3333V6.66667H30V16.6667H23.3333ZM0 60V33.3333H6.66667V36.6667H16.6667V26.6667H13.3333V20H40V26.6667H36.6667V36.6667H46.6667V33.3333H53.3333V60H46.6667V56.6667H6.66667V60H0ZM6.66667 50H46.6667V43.3333H30V26.6667H23.3333V43.3333H6.66667V50Z"
        fill="#2F80ED"
      />
    </svg>
  );
}
